:host {
  display: block;
  height: auto;

  .hide {
    display: none !important;
  }

  .margin-bottom-20 {
    margin-bottom: 20px !important;
  }

  .chat-message {
    border-radius: 0 10px 10px 10px;

    &__user {
      display: flex;
      align-items: center;
      margin-bottom: 10px;

      module-avatar-component,
      img,
      &--avatar {
        margin-right: 10px;
      }

      span {
        color: #333;
        color: var(--font-primary);
        font-size: 15px;
        font-weight: 600;
      }

      &--avatar {
        border-radius: 50%;
        width: 30px;
        height: 30px;
        object-fit: contain;
      }

      img {
        border-radius: 50%;
        width: 30px;
        height: 30px;
        object-fit: contain;
      }
    }

    &__message {
      margin-bottom: 10px;

      div:first-child {
        box-sizing: border-box;
        display: inline-block;
        width: auto;
        padding: 20px 18px;
        border-radius: 0 10px 10px 10px;
        background-color: #ffffff;
        background-color: var(--bg-primary);
        max-width: 90%;
      }
    }

    &__time {
      margin-bottom: 20px;
      font-size: 12px;
      color: #333;
      color: var(--font-primary);
    }

    &--right {
      .chat-message {
        &__user,
        &__message,
        &__time {
          flex-direction: row-reverse;
          display: flex;
        }

        &__user {
          module-avatar-component,
          img {
            margin-left: 10px;
            margin-right: 0;
          }
        }

        &__message {
          div:first-child {
            box-sizing: border-box;
            border-radius: 10px 0 10px 10px;
            background-color: #0098ff;
            color: white;
          }
        }
      }
    }
  }

  /* -------------------------------------------------------------------------- */
  /*                                 RESPONSIVE                                 */
  /* -------------------------------------------------------------------------- */

  // Medium devices (tablets, 768px and up)
  @media (max-width: 768px) {
    .chat-message {
      &__message {
        div:first-child {
          max-width: 100%;
        }
      }
    }
  }

  /* -------------------------------------------------------------------------- */
  /*                                  FULL MODE                                 */
  /* -------------------------------------------------------------------------- */
  .chat-message--full {
    .chat-message {
      &__user {
        span {
          color: white;
        }
      }
      &__time {
        color: white;
      }
    }
  }
}
